var exports = {
  "zz": "OptionsHeading__6H_xAG",
  "J1": "SingleSelectForm__ToXt0L",
  "ZT": "WorkflowEnabledStatus__0HHjmZ",
};

module.exports = exports;
